import type { RouteRecordRaw } from 'vue-router';

// MCP OAuth consent page. Standalone full-screen card — `minimal` chrome so
// the sidebar / banner don't frame a page the user reached from an external
// MCP client. Not `authFree`: an unauthenticated hit must bounce to
// /login?next=<consent path>, which the global guard does via isSafeNext.
const mcpRoutes: RouteRecordRaw[] = [
  {
    path: '/mcp-authorize',
    name: 'mcp-authorize',
    component: () => import('@/domains/mcp/views/McpAuthorizeView.vue'),
    meta: { renderer: 'native', layout: 'minimal' },
  },
];

export default mcpRoutes;
